import { PropsWithChildren } from 'react';
import { AsideDialog, UNSAVED_CHANGES_DIALOG_NAME, UnsavedChangesDialog, useDialogs } from '@mews-commander/ui';
import { lt } from '@mews/framework';

interface Props {
    dialogName: string;
    formTitle: Mews.TextKey;
    hasDirtyFields: boolean;
    isLoading: boolean;
    submit: () => void;
    submitLabel: Mews.TextKey;
}

export const SellLimitDialogForm = ({
    children,
    dialogName,
    formTitle,
    hasDirtyFields,
    isLoading,
    submit,
    submitLabel,
}: PropsWithChildren<Props>) => {
    const { closeDialog, openDialog } = useDialogs();

    const handleClose = () => {
        if (hasDirtyFields) {
            openDialog(
                <UnsavedChangesDialog
                    onCancel={() => closeDialog(UNSAVED_CHANGES_DIALOG_NAME)}
                    onDiscardChanges={() => {
                        closeDialog(UNSAVED_CHANGES_DIALOG_NAME);
                        closeDialog(dialogName);
                    }}
                />,
                UNSAVED_CHANGES_DIALOG_NAME
            );
        } else {
            closeDialog(dialogName);
        }
    };

    return (
        <AsideDialog
            active
            onClose={handleClose}
            title={lt(formTitle)}
            actions={[
                {
                    children: lt('Cancel'),
                    variant: 'tertiary',
                    onClick: handleClose,
                    type: 'button',
                },
                {
                    children: lt(submitLabel),
                    variant: 'primary',
                    onClick: submit,
                    type: 'submit',
                },
            ]}
            loading={isLoading}
        >
            {children}
        </AsideDialog>
    );
};
